<div mat-dialog-content>
    <app-patient-view-component [patientview]="patient" #patientViewComponent></app-patient-view-component>
</div>
<div class="clearfix">
    <div class="pull-right">
        <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Salir</button>
    </div>
</div>